import { Status } from "../../hooks/useDragNDrop.hook";

type EmptyListDescription = {
  [key in Status]: string;
};
export const EMPTY_LIST_DESCRIPTION: EmptyListDescription = {
  [Status.SET]: "Place your priorities in this field",
  [Status.NO_SET]: "All priority types have been moved to Your set",
} as const;
